export const NEW_CHARTS_ENABLED = true
